import { render } from "./loaderPOS.vue?vue&type=template&id=754abf8d&scoped=true"
const script = {}

import "./loaderPOS.vue?vue&type=style&index=0&id=754abf8d&lang=scss&scoped=true"

import exportComponent from "/Users/ittiwutwongsawat/Documents/GitHub/clinic/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-754abf8d"]])

export default __exports__